import { initHotjar } from "@/utils/analytics/hotjar";
import { initGoogleAnalytics } from "@/utils/analytics/gtag";

export function initAnalytic() {
    initHotjar()
    initGoogleAnalytics()
}
